/**
 * @generated SignedSource<<e04acaea6adb2c68e2e93163f19919fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useDisableShippingSubmit_deliveryOptions$data = ReadonlyArray<{
  readonly isLocalPickup: boolean | null;
  readonly serviceId: string | null;
  readonly showQuoteAsPending: boolean | null;
  readonly " $fragmentType": "useDisableShippingSubmit_deliveryOptions";
}>;
export type useDisableShippingSubmit_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: useDisableShippingSubmit_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"useDisableShippingSubmit_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useDisableShippingSubmit_deliveryOptions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocalPickup",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showQuoteAsPending",
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "5f7522f341d3044f9c1e5ff1e8c96113";

export default node;
